var pageScroll = {
	now : 0,
	ready : false,

	init : function(){
		var _this = this;
		_this.ready = true;
	},
	onScroll : function(){
		var _this = this;
		if( $('body').is('.template-index') ){
			if ( 750 > windowHeight ){
				var hh = windowHeight - $('store-header').height();
			} else {
				var hh = 750 - $('store-header').height();
			}

			if ( hh > windowTop ){
				$('body').addClass('header-transparent')
			}else {
				$('body').removeClass('header-transparent')
			}
		}
		_this.now = windowTop;
	},

	// IntersectionObserver
	initIO : function(){
		var _this = this;
		_this.$targets = document.querySelectorAll('.io,.io-o');
		var options = {
			threshold: 0
		};
		if( _this.$targets ){
			_this.observer = new IntersectionObserver( _this.listerner, options );
			_this.$targets.forEach(function(e,i) {
				_this.observer.observe(e);
				var y = $(e).offset().top;
				if( y < windowHeight ){
					$(e).css({
						'transition-delay' : i * anim.io.d + 's'
					});
					e.classList.add('on');
				}
			});
		}
	},
	listerner : function(changes) {
		var _this = this;
		changes.forEach(function(c) {
			var target = c.target,
			isIntersecting = c.isIntersecting;
			if ( isIntersecting ) {
				target.classList.add('on');
			}
		});
	},
	onReset : function(){
		windowTop  = 0;
		this.ready = false;
	},
	onDestroy : function() {
		var _this = this;
		if( _this.$targets ){
			_this.$targets.forEach(function(e) {
				_this.observer.disconnect(e);
			});
			_this.observer = null;
		}
	},
}

$(document).on({
	click : function(e){
		e.preventDefault();
		var $to = $($(this).data('to'));
		if( $to.length ){
			var y = $to.offset().top;
			TweenLite.to( $(window), 0.6, {scrollTo:{ y: y, autoKill: false }});
		}
	}
},'.js-scroll-to');
